module.exports = __webpack_public_path__ + "static/media/shorts-accept-icon-1.2b1f068f.png";